<template>
  <div class="flex flex-col h-full">
    <p v-if="businessType === 'murshe'" class="text-sm bg-blue-100 p-4 rounded mt-2">
      <strong>שימו ❤️</strong>
      אנו נשלח ללקוחות קבלה במייל, ונייצר חשבונית מס לשימוש חשבונאי במערכת ezCount באופן אוטומטי
    </p>
    <p v-else class="text-sm bg-blue-100 p-4 rounded mt-2">
      <strong>שימו ❤️</strong>
      קבלה תישלח אל הלקוחות באופן אוטומטי כמה דקות לאחר ביצוע התשלום
    </p>

    <label
      class="font-medium mb-1"
      for="businessType"
      style="margin-top: 0.75rem;">סוג עסק</label>
    <div class="flex flex-wrap gap-3">
      <div class="flex align-items-center">
        <RadioButton
          v-model="businessType"
          inputId="patur"
          name="patur"
          value="patur" />
        <label for="patur" class="mr-2">עוסק פטור</label>
      </div>
      <div class="flex align-items-center">
        <RadioButton
          v-model="businessType"
          inputId="murshe"
          name="murshe"
          value="murshe" />
        <label for="ingredient2" class="mr-2">עוסק מורשה</label>
      </div>
    </div>

    <label
      class="font-medium mb-1"
      for="masof"
      style="margin-top: 0.75rem;">מספר מסוף</label>
    <input-text
      id="masof"
      v-model="credentials.masof"
      placeholder="*****"
    />
    <label
      class="font-medium mb-1"
      for="PassP"
      style="margin-top: 0.75rem;">קוד PassP</label>
    <input-text
      id="PassP"
      v-model="credentials.paas"
      placeholder="*****"
    />
    <label
      class="font-medium mb-1"
      for="yaadApiKey"
      style="margin-top: 0.75rem;">מזהה API</label>
    <input-text
      id="yaadApiKey"
      v-model="credentials.key"
      placeholder="*****"
    />

    <div class="w-full mt-6 flex flex-col gap-2">
      <Button
        label="הבא"
        class="w-full"
        style="display: flex; flex-grow: 1"
        :disabled="!filledEverything"
        @click="completeIntegration"
        :loading="isLoading"
      />
      <Button
        label="הקודם"
        outlined
        class=" w-full !rounded-3xl"
        style="display: flex; flex-grow: 1"
        @click="$emit('prev')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { HypIntegrationParams, PaymentProvider } from '@torim-app/types';
import { SettingsApi } from '@app/api/admin';
import { useToast } from 'vue-toastification';

const emit = defineEmits(['next', 'prev']);
const toast = useToast();

const isLoading = ref(false);
const businessType = ref<'murshe' | 'patur'>();
const credentials = ref<HypIntegrationParams>({
  key: '',
  masof: '',
  paas: ''
});

const filledEverything = computed<boolean>(() => {
  console.log('businessType.value', businessType.value);
  console.log('Object.values(credentials).every(x => !!x)', Object.values(credentials).every(x => !!x));
  return !!businessType.value && Object.values(credentials.value).every(x => !!x);
});

const completeIntegration = async () => {
  if (filledEverything.value) {
    isLoading.value = true;
    try {
      await SettingsApi.updateSettingsAddPaymentIntegration({
        credentials: credentials.value,
        provider: PaymentProvider.HYP
      });
      emit('next');
    } catch (e) {
      toast.error('לא הצלחנו להוסיף את החיבור לHyp');
      console.log(e);
    } finally {
      isLoading.value = true;
    }
  }
};


</script>

<style scoped lang="scss">

</style>
